import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./design/base.css";
import "./components/prayerWidget.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
   <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, "")}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
